import { render, staticRenderFns } from "./printer_config.vue?vue&type=template&id=c199321c&scoped=true"
import script from "./printer_config.vue?vue&type=script&lang=js"
export * from "./printer_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c199321c",
  null
  
)

export default component.exports